import { Link } from './link.jsx';

/**
 * A link to an account detail page.
 *
 * @param {Object} props
 * @param {string} props.id — account id
 * @param {string} props.name — account display name
 * @returns {import('react').ReactElement}
 */
export function AccountLink({ id, name }) {
	return <Link to={'/accounts/' + id} className="link">{name}</Link>;
}
